export default __webpack_public_path__ + "static/media/sf_2.776aa2d4.PNG";